export default [
	{  // 账号列表
		path: 'sys_user_list',
		name: 'm_sysmanage_user',
		component: () => import('@/pages/system/sys_user_list')
	}, {  // 角色列表
		path: 'role_list',
		name: 'm_system_role',
		component: () => import('@/pages/system/system_role_list')
	}, {  // 新建角色
		path: 'role_add',
		name: 'role_add',
		meta: {
			title: '新建角色'
		},
		component: () => import('@/pages/system/system_role_add')
	}, {  // 编辑角色
		path: 'role_edit/:id',
		name: 'role_edit',
		meta: {
			title: '编辑角色'
		},
		props: route => route.params,
		component: () => import('@/pages/system/system_role_edit')
	}, {  // 系统配置
		path: 'platform_config',
		name: 'm_platform_config',
		component: () => import('@/pages/system/platform_config')
	}, {  // 商城配置
		path: 'mall_config',
		name: 'm_mall_config',
		component: () => import('@/pages/system/mall_config')
	}, {  // 关于我们
		path: 'about',
		name: 'm_about',
		component: () => import('@/pages/system/about')
	},{  // EN版购买咨询
		path: 'feedback_list',
		name: 'm_feedback',
		component: () => import('@/pages/system/feedback')
	},{  // 独家素材购买咨询
		path: 'consult_list',
		name: 'm_consult',
		component: () => import('@/pages/system/consult_list')
	}
];